import { ImageWrapper } from "./styles";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useEffect, useState } from "react";

const SmartImage: React.FC<{ src: string; blockDownload?: boolean; isOwner?: boolean }> = ({
  src,
  blockDownload = true,
  isOwner = false,
}) => {
  const [isVertical, setIsVertical] = useState(false)
  const { isMobile } = useWindowSize()

  useEffect(() => {
    const img = new window.Image()
    img.src = src
    img.onload = () => {
      setIsVertical(img.height > img.width)
    }
  }, [src])

  return (
    <ImageWrapper isVertical={isVertical} isMobile={isMobile}>
      <img
        src={src}
        onContextMenu={e => blockDownload && !isOwner ? e.preventDefault() : undefined}
        alt=""
      />
    </ImageWrapper>
  )
}

export default SmartImage;